import { LeadCaptureWizard } from './LeadCaptureWizard';
import { useLeads } from '../hooks';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card';

export function LeadsCapturePageRoute() {
  const { data: leads = [], isLoading } = useLeads();

  return (
    <div className="container max-w-2xl space-y-8 py-6">
      <div>
        <h1 className="text-2xl font-bold">Capture lead</h1>
        <p className="text-muted-foreground">
          Add a new sales lead: choose stakeholder type, capture from card or manual entry, then save.
        </p>
      </div>

      <LeadCaptureWizard />

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Recent leads</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <p className="text-sm text-muted-foreground">Loading…</p>
          ) : leads.length === 0 ? (
            <p className="text-sm text-muted-foreground">No leads yet. Capture one above.</p>
          ) : (
            <ul className="space-y-2">
              {leads.slice(0, 10).map((lead) => (
                <li key={lead.id} className="flex justify-between text-sm">
                  <span>
                    {lead.name}
                    {lead.company ? ` · ${lead.company}` : ''}
                  </span>
                  <span className="text-muted-foreground">{lead.stakeholder_type?.label ?? lead.stakeholder_type?.slug ?? '—'}</span>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
